export default "__VITE_ASSET__BismlJOh__"